import { Component, OnInit } from '@angular/core';
import { AppUrlConstants } from '../../appconfig';

export interface CookieConsent {
  essential: boolean;
  analytics: boolean;
  marketing: boolean;
  updatedAt: string;
}

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss']
})
export class CookieConsentComponent implements OnInit {
  static readonly storageKey = 'cookieConsent';

  showBanner = false;
  showPreferences = false;
  analytics = false;
  marketing = false;
  termsUrl = '/' + AppUrlConstants.termsAndConditionUrl;

  ngOnInit() {
    this.showBanner = !CookieConsentComponent.getConsent();
  }

  static getConsent(): CookieConsent {
    try {
      const value = localStorage.getItem(CookieConsentComponent.storageKey);
      // choices saved by the earlier accept/reject-only banner
      if (value === 'accepted' || value === 'rejected') {
        const accepted = value === 'accepted';
        return { essential: true, analytics: accepted, marketing: accepted, updatedAt: null };
      }
      return value ? JSON.parse(value) : null;
    } catch (e) {
      return null;
    }
  }

  openBanner() {
    const consent = CookieConsentComponent.getConsent();
    this.analytics = consent ? consent.analytics : false;
    this.marketing = consent ? consent.marketing : false;
    this.showPreferences = false;
    this.showBanner = true;
  }

  togglePreferences() {
    this.showPreferences = !this.showPreferences;
  }

  acceptAll() {
    this.save(true, true);
  }

  rejectAll() {
    this.save(false, false);
  }

  savePreferences() {
    this.save(this.analytics, this.marketing);
  }

  private save(analytics: boolean, marketing: boolean) {
    const consent: CookieConsent = { essential: true, analytics, marketing, updatedAt: new Date().toISOString() };
    try {
      localStorage.setItem(CookieConsentComponent.storageKey, JSON.stringify(consent));
    } catch (e) { }
    this.showBanner = false;
  }
}
